export default "__VITE_ASSET__Dv_U5SdT__"